module.exports = __webpack_public_path__ + "static/media/dochilove05.720873e0.jpg";